<style>
    * {
        all: revert;
    }
</style>

<script lang="ts">
    import { _ } from 'svelte-i18n';

    import SelectInput, {
        OptionType
    } from '@eqs/cms-svelte-irtools/form/components/SelectInput.svelte';
    import { TextInputSvelte } from '@eqs/cms-svelte-irtools/form/components';
    import {
        combineValidates,
        email as emailValidator,
        required
    } from '@eqs/cms-svelte-irtools/form';
    import type { PersonInfoType } from '../utils/types';
    import type { ValidateFunction } from '@eqs/cms-svelte-irtools/form';
    import { LOCALE } from '../../../config';

    export let data: PersonInfoType;
    export let distributionList: string[] = [];
    export let supportedDist: string[] = [];
    let inputError: { [key: string]: undefined | string } = {};
    let dl_analyst: string;
    let dl_investor: string;
    let dl_press: string;
    let dl_partner: string;
    let dl_other: string;
    let countryOptions: OptionType[];
    const genderOptions: OptionType[] = [
        { name: $_('dropdown_options.salutation.male'), value: 'male' },
        { name: $_('dropdown_options.salutation.female'), value: 'female' },
        { name: $_('dropdown_options.salutation.neutral'), value: 'neutral' }
    ];

    if (LOCALE === 'en') {
        // English
        countryOptions = [
            { value: 'AF', name: 'Afghanistan' },
            { value: 'AX', name: 'Åland Islands' },
            { value: 'AL', name: 'Albania' },
            { value: 'DZ', name: 'Algeria' },
            { value: 'AS', name: 'American Samoa' },
            { value: 'AD', name: 'Andorra' },
            { value: 'AO', name: 'Angola' },
            { value: 'AI', name: 'Anguilla' },
            { value: 'AQ', name: 'Antarctica' },
            { value: 'AG', name: 'Antigua and Barbuda' },
            { value: 'AR', name: 'Argentina' },
            { value: 'AM', name: 'Armenia' },
            { value: 'AW', name: 'Aruba' },
            { value: 'AU', name: 'Australia' },
            { value: 'AT', name: 'Austria' },
            { value: 'AZ', name: 'Azerbaijan' },
            { value: 'BS', name: 'Bahamas' },
            { value: 'BH', name: 'Bahrain' },
            { value: 'BD', name: 'Bangladesh' },
            { value: 'BB', name: 'Barbados' },
            { value: 'BY', name: 'Belarus' },
            { value: 'BE', name: 'Belgium' },
            { value: 'BZ', name: 'Belize' },
            { value: 'BJ', name: 'Benin' },
            { value: 'BM', name: 'Bermuda' },
            { value: 'BT', name: 'Bhutan' },
            { value: 'BO', name: 'Bolivia' },
            { value: 'BA', name: 'Bosnia and Herzegovina' },
            { value: 'BW', name: 'Botswana' },
            { value: 'BV', name: 'Bouvet Island' },
            { value: 'BR', name: 'Brazil' },
            { value: 'IO', name: 'British Indian Ocean Territory' },
            { value: 'BN', name: 'Brunei Darussalam' },
            { value: 'BG', name: 'Bulgaria' },
            { value: 'BF', name: 'Burkina Faso' },
            { value: 'BI', name: 'Burundi' },
            { value: 'KH', name: 'Cambodia' },
            { value: 'CM', name: 'Cameroon' },
            { value: 'CA', name: 'Canada' },
            { value: 'CV', name: 'Cape Verde' },
            { value: 'KY', name: 'Cayman Islands' },
            { value: 'CF', name: 'Central African Republic' },
            { value: 'TD', name: 'Chad' },
            { value: 'CL', name: 'Chile' },
            { value: 'CN', name: 'China' },
            { value: 'CX', name: 'Christmas Island' },
            { value: 'CC', name: 'Cocos (Keeling) Islands' },
            { value: 'CO', name: 'Colombia' },
            { value: 'KM', name: 'Comoros' },
            { value: 'CG', name: 'Congo' },
            { value: 'CD', name: 'Congo, The Democratic Republic of The' },
            { value: 'CK', name: 'Cook Islands' },
            { value: 'CR', name: 'Costa Rica' },
            { value: 'CI', name: "Cote D'ivoire" },
            { value: 'HR', name: 'Croatia' },
            { value: 'CU', name: 'Cuba' },
            { value: 'CY', name: 'Cyprus' },
            { value: 'CZ', name: 'Czechia' },
            { value: 'DK', name: 'Denmark' },
            { value: 'DJ', name: 'Djibouti' },
            { value: 'DM', name: 'Dominica' },
            { value: 'DO', name: 'Dominican Republic' },
            { value: 'EC', name: 'Ecuador' },
            { value: 'EG', name: 'Egypt' },
            { value: 'SV', name: 'El Salvador' },
            { value: 'GQ', name: 'Equatorial Guinea' },
            { value: 'ER', name: 'Eritrea' },
            { value: 'EE', name: 'Estonia' },
            { value: 'ET', name: 'Ethiopia' },
            { value: 'FK', name: 'Falkland Islands (Malvinas)' },
            { value: 'FO', name: 'Faroe Islands' },
            { value: 'FJ', name: 'Fiji' },
            { value: 'FI', name: 'Finland' },
            { value: 'FR', name: 'France' },
            { value: 'GF', name: 'French Guiana' },
            { value: 'PF', name: 'French Polynesia' },
            { value: 'TF', name: 'French Southern Territories' },
            { value: 'GA', name: 'Gabon' },
            { value: 'GM', name: 'Gambia' },
            { value: 'GE', name: 'Georgia' },
            { value: 'DE', name: 'Germany' },
            { value: 'GH', name: 'Ghana' },
            { value: 'GI', name: 'Gibraltar' },
            { value: 'GR', name: 'Greece' },
            { value: 'GL', name: 'Greenland' },
            { value: 'GD', name: 'Grenada' },
            { value: 'GP', name: 'Guadeloupe' },
            { value: 'GU', name: 'Guam' },
            { value: 'GT', name: 'Guatemala' },
            { value: 'GG', name: 'Guernsey' },
            { value: 'GN', name: 'Guinea' },
            { value: 'GW', name: 'Guinea-bissau' },
            { value: 'GY', name: 'Guyana' },
            { value: 'HT', name: 'Haiti' },
            { value: 'HM', name: 'Heard Island and Mcdonald Islands' },
            { value: 'VA', name: 'Holy See (Vatican City State)' },
            { value: 'HN', name: 'Honduras' },
            { value: 'HK', name: 'Hong Kong' },
            { value: 'HU', name: 'Hungary' },
            { value: 'IS', name: 'Iceland' },
            { value: 'IN', name: 'India' },
            { value: 'ID', name: 'Indonesia' },
            { value: 'IR', name: 'Iran, Islamic Republic of' },
            { value: 'IQ', name: 'Iraq' },
            { value: 'IE', name: 'Ireland' },
            { value: 'IM', name: 'Isle of Man' },
            { value: 'IL', name: 'Israel' },
            { value: 'IT', name: 'Italy' },
            { value: 'JM', name: 'Jamaica' },
            { value: 'JP', name: 'Japan' },
            { value: 'JE', name: 'Jersey' },
            { value: 'JO', name: 'Jordan' },
            { value: 'KZ', name: 'Kazakhstan' },
            { value: 'KE', name: 'Kenya' },
            { value: 'KI', name: 'Kiribati' },
            { value: 'KP', name: "Korea, Democratic People's Republic of" },
            { value: 'KR', name: 'Korea, Republic of' },
            { value: 'KW', name: 'Kuwait' },
            { value: 'KG', name: 'Kyrgyzstan' },
            { value: 'LA', name: "Lao People's Democratic Republic" },
            { value: 'LV', name: 'Latvia' },
            { value: 'LB', name: 'Lebanon' },
            { value: 'LS', name: 'Lesotho' },
            { value: 'LR', name: 'Liberia' },
            { value: 'LY', name: 'Libyan Arab Jamahiriya' },
            { value: 'LI', name: 'Liechtenstein' },
            { value: 'LT', name: 'Lithuania' },
            { value: 'LU', name: 'Luxembourg' },
            { value: 'MO', name: 'Macao' },
            { value: 'MK', name: 'Macedonia, The Former Yugoslav Republic of' },
            { value: 'MG', name: 'Madagascar' },
            { value: 'MW', name: 'Malawi' },
            { value: 'MY', name: 'Malaysia' },
            { value: 'MV', name: 'Maldives' },
            { value: 'ML', name: 'Mali' },
            { value: 'MT', name: 'Malta' },
            { value: 'MH', name: 'Marshall Islands' },
            { value: 'MQ', name: 'Martinique' },
            { value: 'MR', name: 'Mauritania' },
            { value: 'MU', name: 'Mauritius' },
            { value: 'YT', name: 'Mayotte' },
            { value: 'MX', name: 'Mexico' },
            { value: 'FM', name: 'Micronesia, Federated States of' },
            { value: 'MD', name: 'Moldova, Republic of' },
            { value: 'MC', name: 'Monaco' },
            { value: 'MN', name: 'Mongolia' },
            { value: 'ME', name: 'Montenegro' },
            { value: 'MS', name: 'Montserrat' },
            { value: 'MA', name: 'Morocco' },
            { value: 'MZ', name: 'Mozambique' },
            { value: 'MM', name: 'Myanmar' },
            { value: 'NA', name: 'Namibia' },
            { value: 'NR', name: 'Nauru' },
            { value: 'NP', name: 'Nepal' },
            { value: 'NL', name: 'Netherlands' },
            { value: 'AN', name: 'Netherlands Antilles' },
            { value: 'NC', name: 'New Caledonia' },
            { value: 'NZ', name: 'New Zealand' },
            { value: 'NI', name: 'Nicaragua' },
            { value: 'NE', name: 'Niger' },
            { value: 'NG', name: 'Nigeria' },
            { value: 'NU', name: 'Niue' },
            { value: 'NF', name: 'Norfolk Island' },
            { value: 'MP', name: 'Northern Mariana Islands' },
            { value: 'NO', name: 'Norway' },
            { value: 'OM', name: 'Oman' },
            { value: 'PK', name: 'Pakistan' },
            { value: 'PW', name: 'Palau' },
            { value: 'PS', name: 'Palestinian Territory, Occupied' },
            { value: 'PA', name: 'Panama' },
            { value: 'PG', name: 'Papua New Guinea' },
            { value: 'PY', name: 'Paraguay' },
            { value: 'PE', name: 'Peru' },
            { value: 'PH', name: 'Philippines' },
            { value: 'PN', name: 'Pitcairn' },
            { value: 'PL', name: 'Poland' },
            { value: 'PT', name: 'Portugal' },
            { value: 'PR', name: 'Puerto Rico' },
            { value: 'QA', name: 'Qatar' },
            { value: 'RE', name: 'Reunion' },
            { value: 'RO', name: 'Romania' },
            { value: 'RU', name: 'Russian Federation' },
            { value: 'RW', name: 'Rwanda' },
            { value: 'SH', name: 'Saint Helena' },
            { value: 'KN', name: 'Saint Kitts and Nevis' },
            { value: 'LC', name: 'Saint Lucia' },
            { value: 'PM', name: 'Saint Pierre and Miquelon' },
            { value: 'VC', name: 'Saint Vincent and The Grenadines' },
            { value: 'WS', name: 'Samoa' },
            { value: 'SM', name: 'San Marino' },
            { value: 'ST', name: 'Sao Tome and Principe' },
            { value: 'SA', name: 'Saudi Arabia' },
            { value: 'SN', name: 'Senegal' },
            { value: 'RS', name: 'Serbia' },
            { value: 'SC', name: 'Seychelles' },
            { value: 'SL', name: 'Sierra Leone' },
            { value: 'SG', name: 'Singapore' },
            { value: 'SK', name: 'Slovakia' },
            { value: 'SI', name: 'Slovenia' },
            { value: 'SB', name: 'Solomon Islands' },
            { value: 'SO', name: 'Somalia' },
            { value: 'ZA', name: 'South Africa' },
            {
                value: 'GS',
                name: 'South Georgia and The South Sandwich Islands'
            },
            { value: 'ES', name: 'Spain' },
            { value: 'LK', name: 'Sri Lanka' },
            { value: 'SD', name: 'Sudan' },
            { value: 'SR', name: 'Suriname' },
            { value: 'SJ', name: 'Svalbard and Jan Mayen' },
            { value: 'SZ', name: 'Swaziland' },
            { value: 'SE', name: 'Sweden' },
            { value: 'CH', name: 'Switzerland' },
            { value: 'SY', name: 'Syrian Arab Republic' },
            { value: 'TW', name: 'Taiwan, Province of China' },
            { value: 'TJ', name: 'Tajikistan' },
            { value: 'TZ', name: 'Tanzania, United Republic of' },
            { value: 'TH', name: 'Thailand' },
            { value: 'TL', name: 'Timor-leste' },
            { value: 'TG', name: 'Togo' },
            { value: 'TK', name: 'Tokelau' },
            { value: 'TO', name: 'Tonga' },
            { value: 'TT', name: 'Trinidad and Tobago' },
            { value: 'TN', name: 'Tunisia' },
            { value: 'TR', name: 'Turkey' },
            { value: 'TM', name: 'Turkmenistan' },
            { value: 'TC', name: 'Turks and Caicos Islands' },
            { value: 'TV', name: 'Tuvalu' },
            { value: 'UG', name: 'Uganda' },
            { value: 'UA', name: 'Ukraine' },
            { value: 'AE', name: 'United Arab Emirates' },
            { value: 'GB', name: 'United Kingdom' },
            { value: 'US', name: 'United States of America' },
            { value: 'UY', name: 'Uruguay' },
            { value: 'UZ', name: 'Uzbekistan' },
            { value: 'VU', name: 'Vanuatu' },
            { value: 'VE', name: 'Venezuela' },
            { value: 'VN', name: 'Viet Nam' },
            { value: 'VG', name: 'Virgin Islands, British' },
            { value: 'VI', name: 'Virgin Islands, U.S.' },
            { value: 'WF', name: 'Wallis and Futuna' },
            { value: 'EH', name: 'Western Sahara' },
            { value: 'YE', name: 'Yemen' },
            { value: 'ZM', name: 'Zambia' },
            { value: 'ZW', name: 'Zimbabwe ' }
        ];
    } else {
        // German
        countryOptions = [
            { value: 'AF', name: 'Afghanistan' },
            { value: 'EG', name: 'Ägypten' },
            { value: 'AX', name: 'Åland' },
            { value: 'AL', name: 'Albanien' },
            { value: 'DZ', name: 'Algerien' },
            { value: 'AS', name: 'Amerikanisch-Samoa' },
            { value: 'VI', name: 'Amerikanische Jungferninseln' },
            { value: 'AD', name: 'Andorra' },
            { value: 'AO', name: 'Angola' },
            { value: 'AI', name: 'Anguilla' },
            { value: 'AQ', name: 'Antarktis' },
            { value: 'AG', name: 'Antigua und Barbuda' },
            { value: 'GQ', name: 'Äquatorialguinea' },
            { value: 'AR', name: 'Argentinien' },
            { value: 'AM', name: 'Armenien' },
            { value: 'AW', name: 'Aruba' },
            { value: 'AC', name: 'Ascension' },
            { value: 'AZ', name: 'Aserbaidschan' },
            { value: 'ET', name: 'Äthiopien' },
            { value: 'AU', name: 'Australien' },
            { value: 'BS', name: 'Bahamas' },
            { value: 'BH', name: 'Bahrain' },
            { value: 'BD', name: 'Bangladesch' },
            { value: 'BB', name: 'Barbados' },
            { value: 'BY', name: 'Belarus (Weißrussland)' },
            { value: 'BE', name: 'Belgien' },
            { value: 'BZ', name: 'Belize' },
            { value: 'BJ', name: 'Benin' },
            { value: 'BM', name: 'Bermuda' },
            { value: 'BT', name: 'Bhutan' },
            { value: 'BO', name: 'Bolivien' },
            { value: 'BA', name: 'Bosnien und Herzegowina' },
            { value: 'BW', name: 'Botswana' },
            { value: 'BV', name: 'Bouvetinsel' },
            { value: 'BR', name: 'Brasilien' },
            { value: 'VG', name: 'Britische Jungferninseln' },
            { value: 'IO', name: 'Britisches Territorium im Indischen Ozean' },
            { value: 'BN', name: 'Brunei Darussalam' },
            { value: 'BG', name: 'Bulgarien' },
            { value: 'BF', name: 'Burkina Faso' },
            { value: 'BI', name: 'Burundi' },
            { value: 'EA', name: 'Ceuta, Melilla' },
            { value: 'CL', name: 'Chile' },
            { value: 'CN', name: 'Volksrepublik China' },
            { value: 'CP', name: 'Clipperton' },
            { value: 'CK', name: 'Cookinseln' },
            { value: 'CR', name: 'Costa Rica' },
            { value: 'CI', name: "Côte d'Ivoire (Elfenbeinküste)" },
            { value: 'DK', name: 'Dänemark' },
            { value: 'DE', name: 'Deutschland' },
            { value: 'DG', name: 'Diego Garcia' },
            { value: 'DM', name: 'Dominica' },
            { value: 'DO', name: 'Dominikanische Republik' },
            { value: 'DJ', name: 'Dschibuti' },
            { value: 'EC', name: 'Ecuador' },
            { value: 'SV', name: 'El Salvador' },
            { value: 'ER', name: 'Eritrea' },
            { value: 'EE', name: 'Estland' },
            { value: 'FK', name: 'Falklandinseln' },
            { value: 'FO', name: 'Färöer' },
            { value: 'FJ', name: 'Fidschi' },
            { value: 'FI', name: 'Finnland' },
            { value: 'FR', name: 'Frankreich' },
            { value: 'GF', name: 'Französisch-Guayana' },
            { value: 'PF', name: 'Französisch-Polynesien' },
            { value: 'GA', name: 'Gabun' },
            { value: 'GM', name: 'Gambia' },
            { value: 'GE', name: 'Georgien' },
            { value: 'GH', name: 'Ghana' },
            { value: 'GI', name: 'Gibraltar' },
            { value: 'GD', name: 'Grenada' },
            { value: 'GR', name: 'Griechenland' },
            { value: 'GL', name: 'Grönland' },
            { value: 'GB', name: 'Großbritannien' },
            { value: 'GP', name: 'Guadeloupe' },
            { value: 'GU', name: 'Guam' },
            { value: 'GT', name: 'Guatemala' },
            { value: 'GG', name: 'Guernsey (Kanalinsel)' },
            { value: 'GN', name: 'Guinea' },
            { value: 'GW', name: 'Guinea-Bissau' },
            { value: 'GY', name: 'Guyana' },
            { value: 'HT', name: 'Haiti' },
            { value: 'HM', name: 'Heard- und McDonald-Inseln' },
            { value: 'HN', name: 'Honduras' },
            { value: 'HK', name: 'Hongkong' },
            { value: 'IN', name: 'Indien' },
            { value: 'ID', name: 'Indonesien' },
            { value: 'IM', name: 'Insel Man' },
            { value: 'IQ', name: 'Irak' },
            { value: 'IR', name: 'Iran' },
            { value: 'IE', name: 'Irland' },
            { value: 'IS', name: 'Island' },
            { value: 'IL', name: 'Israel' },
            { value: 'IT', name: 'Italien' },
            { value: 'JM', name: 'Jamaika' },
            { value: 'JP', name: 'Japan' },
            { value: 'YE', name: 'Jemen' },
            { value: 'JE', name: 'Jersey (Kanalinsel)' },
            { value: 'JO', name: 'Jordanien' },
            { value: 'KY', name: 'Kaimaninseln' },
            { value: 'KH', name: 'Kambodscha' },
            { value: 'CM', name: 'Kamerun' },
            { value: 'CA', name: 'Kanada' },
            { value: 'IC', name: 'Kanarische Inseln' },
            { value: 'CV', name: 'Kap Verde' },
            { value: 'KZ', name: 'Kasachstan' },
            { value: 'QA', name: 'Katar' },
            { value: 'KE', name: 'Kenia' },
            { value: 'KG', name: 'Kirgisistan' },
            { value: 'KI', name: 'Kiribati' },
            { value: 'CC', name: 'Kokosinseln' },
            { value: 'CO', name: 'Kolumbien' },
            { value: 'KM', name: 'Komoren' },
            { value: 'CD', name: 'Demokratische Republik Kongo' },
            {
                value: 'KP',
                name: 'Demokratische Volksrepublik Korea (Nordkorea)'
            },
            { value: 'KR', name: 'Republik Korea (Südkorea)' },
            { value: 'HR', name: 'Kroatien' },
            { value: 'CU', name: 'Kuba' },
            { value: 'KW', name: 'Kuwait' },
            { value: 'LA', name: 'Laos' },
            { value: 'LS', name: 'Lesotho' },
            { value: 'LV', name: 'Lettland' },
            { value: 'LB', name: 'Libanon' },
            { value: 'LR', name: 'Liberia' },
            { value: 'LY', name: 'Libyen' },
            { value: 'LI', name: 'Liechtenstein' },
            { value: 'LT', name: 'Litauen' },
            { value: 'LU', name: 'Luxemburg' },
            { value: 'MO', name: 'Macao' },
            { value: 'MG', name: 'Madagaskar' },
            { value: 'MW', name: 'Malawi' },
            { value: 'MY', name: 'Malaysia' },
            { value: 'MV', name: 'Malediven' },
            { value: 'ML', name: 'Mali' },
            { value: 'MT', name: 'Malta' },
            { value: 'MA', name: 'Marokko' },
            { value: 'MH', name: 'Marshallinseln' },
            { value: 'MQ', name: 'Martinique' },
            { value: 'MR', name: 'Mauretanien' },
            { value: 'MU', name: 'Mauritius' },
            { value: 'YT', name: 'Mayotte' },
            { value: 'MK', name: 'Mazedonien' },
            { value: 'MX', name: 'Mexiko' },
            { value: 'FM', name: 'Mikronesien' },
            { value: 'MD', name: 'Moldawien (Republik Moldau)' },
            { value: 'MC', name: 'Monaco' },
            { value: 'MN', name: 'Mongolei' },
            { value: 'ME', name: 'Montenegro' },
            { value: 'MS', name: 'Montserrat' },
            { value: 'MZ', name: 'Mosambik' },
            { value: 'MM', name: 'Myanmar (Burma)' },
            { value: 'NA', name: 'Namibia' },
            { value: 'NR', name: 'Nauru' },
            { value: 'NP', name: 'Nepal' },
            { value: 'NC', name: 'Neukaledonien' },
            { value: 'NZ', name: 'Neuseeland' },
            { value: 'NI', name: 'Nicaragua' },
            { value: 'NL', name: 'Niederlande' },
            { value: 'AN', name: 'Niederländische Antillen' },
            { value: 'NE', name: 'Niger' },
            { value: 'NG', name: 'Nigeria' },
            { value: 'NU', name: 'Niue' },
            { value: 'MP', name: 'Nördliche Marianen' },
            { value: 'NF', name: 'Norfolkinsel' },
            { value: 'NO', name: 'Norwegen' },
            { value: 'OM', name: 'Oman' },
            { value: 'XO', name: 'Orbit' },
            { value: 'AT', name: 'Österreich' },
            { value: 'TL', name: 'Osttimor (Timor-Leste)' },
            { value: 'PK', name: 'Pakistan' },
            { value: 'PS', name: 'Palästinensische Autonomiegebiete' },
            { value: 'PW', name: 'Palau' },
            { value: 'PA', name: 'Panama' },
            { value: 'PG', name: 'Papua-Neuguinea' },
            { value: 'PY', name: 'Paraguay' },
            { value: 'PE', name: 'Peru' },
            { value: 'PH', name: 'Philippinen' },
            { value: 'PN', name: 'Pitcairninseln' },
            { value: 'PL', name: 'Polen' },
            { value: 'PT', name: 'Portugal' },
            { value: 'PR', name: 'Puerto Rico' },
            { value: 'TW', name: 'Republik China (Taiwan)' },
            { value: 'CG', name: 'Republik Kongo' },
            { value: 'RE', name: 'Réunion' },
            { value: 'RW', name: 'Ruanda' },
            { value: 'RO', name: 'Rumänien' },
            { value: 'RU', name: 'Russische Föderation' },
            { value: 'BL', name: 'Saint-Barthélemy' },
            { value: 'MF', name: 'Saint-Martin' },
            { value: 'SB', name: 'Salomonen' },
            { value: 'ZM', name: 'Sambia' },
            { value: 'WS', name: 'Samoa' },
            { value: 'SM', name: 'San Marino' },
            { value: 'ST', name: 'São Tomé und Príncipe' },
            { value: 'SA', name: 'Saudi-Arabien' },
            { value: 'SE', name: 'Schweden' },
            { value: 'CH', name: 'Schweiz' },
            { value: 'SN', name: 'Senegal' },
            { value: 'RS', name: 'Serbien' },
            { value: 'SC', name: 'Seychellen' },
            { value: 'SL', name: 'Sierra Leone' },
            { value: 'ZW', name: 'Simbabwe' },
            { value: 'SG', name: 'Singapur' },
            { value: 'SK', name: 'Slowakei' },
            { value: 'SI', name: 'Slowenien' },
            { value: 'SO', name: 'Somalia' },
            { value: 'ES', name: 'Spanien' },
            { value: 'LK', name: 'Sri Lanka' },
            { value: 'SH', name: 'St. Helena' },
            { value: 'KN', name: 'St. Kitts und Nevis' },
            { value: 'LC', name: 'St. Lucia' },
            { value: 'PM', name: 'Saint-Pierre und Miquelon' },
            { value: 'VC', name: 'St. Vincent und die Grenadinen' },
            { value: 'ZA', name: 'Südafrika' },
            { value: 'SD', name: 'Sudan' },
            {
                value: 'GS',
                name: 'Südgeorgien und die Südlichen Sandwichinseln'
            },
            { value: 'SR', name: 'Suriname' },
            { value: 'SJ', name: 'Svalbard und Jan Mayen' },
            { value: 'SZ', name: 'Swasiland' },
            { value: 'SY', name: 'Syrien' },
            { value: 'TJ', name: 'Tadschikistan' },
            { value: 'TZ', name: 'Tansania' },
            { value: 'TH', name: 'Thailand' },
            { value: 'TG', name: 'Togo' },
            { value: 'TK', name: 'Tokelau' },
            { value: 'TO', name: 'Tonga' },
            { value: 'TT', name: 'Trinidad und Tobago' },
            { value: 'TA', name: 'Tristan da Cunha' },
            { value: 'TD', name: 'Tschad' },
            { value: 'CZ', name: 'Tschechische Republik' },
            { value: 'TN', name: 'Tunesien' },
            { value: 'TR', name: 'Türkei' },
            { value: 'TM', name: 'Turkmenistan' },
            { value: 'TC', name: 'Turks- und Caicosinseln' },
            { value: 'TV', name: 'Tuvalu' },
            { value: 'UG', name: 'Uganda' },
            { value: 'UA', name: 'Ukraine' },
            { value: 'HU', name: 'Ungarn' },
            { value: 'UY', name: 'Uruguay' },
            { value: 'UZ', name: 'Usbekistan' },
            { value: 'VU', name: 'Vanuatu' },
            { value: 'VA', name: 'Vatikanstadt' },
            { value: 'VE', name: 'Venezuela' },
            { value: 'AE', name: 'Vereinigte Arabische Emirate' },
            { value: 'US', name: 'Vereinigte Staaten von Amerika (USA)' },
            {
                value: 'GB',
                name: 'Vereinigtes Königreich Großbritannien und Nordirland'
            },
            { value: 'VN', name: 'Vietnam' },
            { value: 'WF', name: 'Wallis und Futuna' },
            { value: 'CX', name: 'Weihnachtsinsel' },
            { value: 'EH', name: 'Westsahara' },
            { value: 'CF', name: 'Zentralafrikanische Republik' },
            { value: 'CY', name: 'Zypern' }
        ];
    }

    const affiliationOptions: OptionType[] = [
        {
            name: $_('dropdown_options.affiliation.analyst'),
            value: 'Analyst'
        },
        {
            name: $_('dropdown_options.affiliation.investor'),
            value: 'Investor'
        },
        { name: $_('dropdown_options.affiliation.press'), value: 'Press' },
        {
            name: $_('dropdown_options.affiliation.partner'),
            value: 'Partner'
        },
        { name: $_('dropdown_options.affiliation.other'), value: 'Other' }
    ];

    if (LOCALE === 'en') {
        dl_analyst = 'analyst-english';
        dl_investor = 'investor-english';
        dl_press = 'press-english';
        dl_partner = 'partner-english';
        dl_other = 'other-english';
    } else {
        dl_analyst = 'analyst-german';
        dl_investor = 'investor-german';
        dl_press = 'presse-german';
        dl_partner = 'partner-german';
        dl_other = 'sonstiges-german';
    }

    const affiliationToDLMap: { [key: string]: string } = {
        Analyst: dl_analyst,
        Investor: dl_investor,
        Press: dl_press,
        Partner: dl_partner,
        Other: dl_other
    };

    // supportedDist = Object.values(affiliationToDLMap);
    // supportedDist = ['ir-en', 'ir-de'];

    let dl = '';

    if (LOCALE === 'en') {
        dl = 'pr-english';
    } else {
        dl = 'pr-german';
    }

    supportedDist = [
        'analyst',
        'analyst-english',
        'analyst-german',
        'investor-english',
        'investor-german',
        'press-english',
        'press-german',
        'partner-english',
        'partner-german',
        'other-english',
        'other-german',
        'pr-english',
        'pr-german'
    ];

    $: {
        if (data.affiliation) {
            distributionList = [affiliationToDLMap[data.affiliation], dl];
            // distributionList = ['ir-en', 'ir-de'];
            // distributionList = ['investor', 'pr-english', 'pr-german'];
        }
    }

    const validates: { [key: string]: ValidateFunction } = {};
    export const validate: ValidateFunction = async () => {
        await combineValidates(...Object.values(validates))();
    };
</script>

<div>
    <!-- <SelectInput
        bind:value="{data.gender}"
        label="{$_('contact_form.labels.salutation')}"
        placeholder="{$_('generic.prompts.please_choose')}"
        options="{genderOptions}"
    /> -->

    <div class="eqs-form-main__element" data-lan="{LOCALE}">
        <TextInputSvelte
            bind:value="{data.email}"
            type="email"
            label="{$_('contact_form.labels.email')} *"
            validators="{[
                required(
                    $_('generic.validation.required', {
                        values: { field: 'email' }
                    })
                ),
                emailValidator(
                    $_('generic.validation.email', {
                        values: { field: 'email' }
                    })
                )
            ]}"
            bind:validate="{validates.email}"
            bind:error="{inputError.email}"
            cssClass="{inputError.email ? 'error' : ''}"
        />
    </div>

    <div class="eqs-form-main__element">
        <TextInputSvelte
            bind:value="{data.firstName}"
            label="{$_('contact_form.labels.first_name')}"
        />
    </div>

    <div class="eqs-form-main__element">
        <TextInputSvelte
            bind:value="{data.lastName}"
            label="{$_('contact_form.labels.last_name')}"
        />
    </div>

    <div class="eqs-form-main__element">
        <TextInputSvelte
            bind:value="{data.jobTitle}"
            label="{$_('contact_form.labels.job_title')}"
        />
    </div>

    <div class="eqs-form-main__element">
        <TextInputSvelte
            bind:value="{data.company}"
            label="{$_('contact_form.labels.company')}"
        />
    </div>

    <div class="eqs-form-main__element">
        <SelectInput
            bind:value="{data.countryCode}"
            label="{$_('contact_form.labels.country')}"
            placeholder="{$_('generic.prompts.please_choose')}"
            options="{countryOptions}"
        />
    </div>

    <div class="eqs-form-main__element">
        <SelectInput
            bind:value="{data.affiliation}"
            label="{$_('contact_form.labels.affiliation')}"
            placeholder="{$_('generic.prompts.please_choose')}"
            options="{affiliationOptions}"
        />
    </div>

    <div class="eqs-form-privacy__element">
        {#if LOCALE === 'en'}
            <div class="privacy">
                <p>
                    I want to receive communications from the Evotec Group. I
                    understand I can unsubscribe at any time. All details on the
                    processing of your personal data can be found in our <a
                        target="_blank"
                        href="https://www.evotec.com/en/about/site-information/privacy-policy"
                        >Privacy Policy
                    </a>.
                </p>
                <p>
                    By submitting this form, you consent to allow Evotec to
                    store and process the personal information you provided
                    above to handle your request.
                </p>
            </div>
        {:else}
            <div class="privacy">
                <p>
                    Ich möchte Mitteilungen von der Evotec-Gruppe erhalten. Ich
                    weiß, dass ich mich jederzeit wieder abmelden kann. Alle
                    Einzelheiten zur Verarbeitung Ihrer persönlichen Daten
                    finden Sie in unserer <a
                        target="_blank"
                        href="https://www.evotec.com/de/privacy-policy"
                        >Datenschutzerklärung
                    </a>.
                </p>
                <p>
                    Mit dem Absenden dieses Formulars erklären Sie sich damit
                    einverstanden, dass Evotec die von Ihnen oben angegebenen
                    personenbezogenen Daten speichert und verarbeitet, um Ihre
                    Anfrage zu bearbeiten.
                </p>
            </div>
        {/if}
    </div>

    <!--     
    <TextInputSvelte
        bind:value="{data.emailReception}"
        type="email"
        label="{$_('contact_form.labels.other_emails.reception')}"
    />
    <TextInputSvelte
        bind:value="{data.streetName}"
        label="{$_('contact_form.labels.street_name')}"
    />
    <TextInputSvelte
        bind:value="{data.postalCode}"
        label="{$_('contact_form.labels.postal_code')}"
    />
    <TextInputSvelte
        bind:value="{data.city}"
        label="{$_('contact_form.labels.city')}"
    />
    <TextInputSvelte
        bind:value="{data.phone}"
        label="{$_('contact_form.labels.phone')}"
    />
    <TextInputSvelte
        bind:value="{data.mobilePhoneBusiness}"
        label="{$_('contact_form.labels.other_phones.mobile_business')}"
    />
    <TextInputSvelte
        bind:value="{data.mobilePhonePrivate}"
        label="{$_('contact_form.labels.other_phones.mobile_private')}"
    />
    <TextInputSvelte
        bind:value="{data.phoneReception}"
        label="{$_('contact_form.labels.other_phones.reception')}"
    />
    <TextInputSvelte
        bind:value="{data.faxReception}"
        label="{$_('contact_form.labels.faxes.reception')} *"
    />
    <TextInputSvelte
        bind:value="{data.age}"
        type="number"
        label="{$_('contact_form.labels.age')}"
    />
    <TextInputSvelte
        bind:value="{data.ageGroup}"
        label="{$_('contact_form.labels.age')}"
    />
-->
</div>
